(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bottoms-size-guide-popup"] && !Shopify.designMode) return;
  try {
    for (const link of document.querySelectorAll('button.bottoms-size-guide-btn')) {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      window.dispatchEvent(new Event('show-bottoms-size-guide'));
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facy-box-assts"] && !Shopify.designMode) return;
  try {
    Fancybox.bind("[data-fancybox]", {
      // Custom options
      Images: {
        zoom: true,
      },
      Toolbar: {
        display: {
          left: [
            "infobar"
          ],
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY"
          ],
          right: [
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
          ],
        },
      },
      Thumbs: {
        autoStart: true,
        position: "bottom"
      },
      Carousel: {
        friction: 0.8,
        center: true,
        infinite: true,
        preload: 3,
      },
      Image: {
        zoom: true,
        fit: "contain",
        wheel: "zoom",
        click: "toggleZoom",
        doubleClick: null,
      },
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-popup"] && !Shopify.designMode) return;
  try {
    for (const link of document.querySelectorAll('button.size-guide-btn')) {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      window.dispatchEvent(new Event('show-size-guide'));
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tops-size-guide-popup"] && !Shopify.designMode) return;
  try {
    for (const link of document.querySelectorAll('button.tops-size-guide-btn')) {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      window.dispatchEvent(new Event('show-size-guide'));
    });
  }
  } catch(e) { console.error(e); }
})();

})();
